<template>
  <div class="flex-col gap-y-md">
    <dd-header-card header="Basis gegevens">
      <dd-form-grid>
        <dd-form-grid-item cols="1">
          <dd-select
              title="Onder pakket"
              data-dusk="parent-id"
              v-model="parent_id"
              @select="getPackage"
              name="parent_id"
          >
            <a-select-option :value="id" v-for="(packageName, id) of packages" :key="id">
              {{ packageName }}
            </a-select-option>
          </dd-select>
        </dd-form-grid-item>
        <dd-form-grid-item cols="1">
          <dd-input
              data-dusk="contract-number"
              name="contractNumber"
              title="Polis nummer"
              v-model="contractNumber"
          />
        </dd-form-grid-item>
        <dd-form-grid-item>
          <dd-select
              :searchable="true"
              name="productLabels"
              title="Labels"
              data-dusk="product-labels"
              v-model="productLabelIds"
              :options="productLabelsOptions"
              mode="multiple"
          />
        </dd-form-grid-item>
        <dd-form-grid-item>
          <dd-select
              :searchable="true"
              name="corporation_id"
              data-dusk="corporation-id"
              title="Maatschappij"
              v-model="corporation_id">
            <a-select-option :value="id" v-for="(agencyName, id) of agencies" :key="id">
              {{ agencyName }}
            </a-select-option>
          </dd-select>
        </dd-form-grid-item>
        <dd-form-grid-item cols="1">
          <dd-date-picker
              name="startDate"
              title="Ingangsdatum"
              data-dusk="start-date"
              v-model="startDate"
              @input="() => {
              syncStartDurationEnd(
                  form,
                  'startDate',
                  'duration',
                  'contractExpirationDate',
                  'duration');
              syncStartDurationEnd(
                  form,
                  'startDate',
                  'payment_term',
                  'expirationDate',
                  'duration');
            }"
          />
        </dd-form-grid-item>
        <dd-form-grid-item>
          <dd-input
              name="duration"
              title="Contractsduur in maanden"
              v-model="duration"
              @input="syncStartDurationEnd(form,'startDate','duration','contractExpirationDate','end', 'months' , null, true)"
              data-dusk="duration"
          />
        </dd-form-grid-item>
        <dd-form-grid-item cols="1">
          <dd-input
              name="payment_term"
              type="number"
              data-dusk="payment-term"
              title="Betaaltermijn in maanden"
              v-model="payment_term"
              @input="syncStartDurationEnd(form, 'startDate', 'payment_term','expirationDate','end', 'months' , null, true)"
          />
        </dd-form-grid-item>
        <dd-form-grid-item cols="1">
          <dd-date-picker
              name="contractExpirationDate"
              data-dusk="contract-expiration-date"
              title="Contract vervaldatum"
              v-model="contractExpirationDate"
              @input="syncStartDurationEnd(form, 'startDate', 'duration', 'contractExpirationDate', 'duration')"
          />
        </dd-form-grid-item>
        <dd-form-grid-item cols="1">
          <dd-date-picker
              name="expirationDate"
              title="Premie vervaldatum"
              data-dusk="expiration-date"
              v-model="expirationDate"
              @input="syncStartDurationEnd(form, 'startDate', 'payment_term','expirationDate','duration')"
          />
        </dd-form-grid-item>
        <dd-form-grid-item v-if="hasMutationCodes" cols="1">
          <dd-select
              :searchable="true"
              name="mutation-code"
              title="Mutatiecode"
              data-dusk="mutation-code"
              v-model="mutation_code"
              :options="mutationCodeOptions"/>
        </dd-form-grid-item>
        <dd-form-grid-item cols="1">
          <dd-date-picker
              data-dusk="mutation-date"
              name="mutation_date"
              title="Mutatiedatum"
              v-model="mutation_date"/>
        </dd-form-grid-item>
        <dd-form-grid-item v-if="isEditing" cols="1">
          <dd-textarea
              data-dusk="mutation-reason"
              name="mutation_reason"
              title="Mutatie reden"
              v-model="mutation_reason"></dd-textarea>
        </dd-form-grid-item>
        <dd-form-grid-item v-if="showNoteDyn1" cols="1">
          <dd-textarea
              data-dusk="note-dyn1"
              name="note_dyn1"
              title="Vrij tekstveld"
              v-model="dyn1"
          ></dd-textarea>
        </dd-form-grid-item>
      </dd-form-grid>
    </dd-header-card>
    <ChooseCoverages/>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import {mapFields} from 'vuex-map-fields';
import syncStartDurationEnd from "~/mixins/syncStartDurationEnd";
import ChooseCoverages from "./ChooseCoverages.vue";
import tenantApi from "~/api/tenant";

export default {
  name: "CreateOrEditDetails",
  components: { ChooseCoverages },
  beforeCreate() {
    tenantApi.getSetting("policy_show_note_dyn1")
      .then((response) => {
        this.setShowNoteDyn1(response?.value)
      });
  },
  methods: {
    ...mapActions(`$_generic_insurance`, {
      getPackage: 'getPackage',
    }),
    ...mapMutations(`$_generic_insurance` ,{
      setShowNoteDyn1: 'SET_SHOW_NOTE_DYN1',
    })
  },
  mixins: [
    syncStartDurationEnd
  ],
  computed: {
    ...mapGetters(`$_generic_insurance`, {
      form: 'form',
      packageId: 'packageId',
      agencies: 'agencies',
      packages: 'packages',
      mutationCodes: 'mutationCodes',
      productLabelsOptions: 'productLabelsOptions',
      isSinglePolicy: 'isSinglePolicy',
      isEditing: 'isEditing',
      showNoteDyn1: "showNoteDyn1",
    }),
    ...mapState(`$_generic_insurance`, {
      package: 'package',
    }),
    ...mapFields(`$_generic_insurance`, [
      "form.parent_id",
      "form.contractNumber",
      "form.corporation_id",
      "form.startDate",
      "form.duration",
      "form.payment_term",
      "form.expirationDate",
      "form.contractExpirationDate",
      "form.mutation_code",
      "form.mutation_date",
      "form.mutation_reason",
      "form.productLabelIds",
      "form.dyn1",
      "form",
    ]),
    // TODO: make more robust solution for this workaround
    hasMutationCodes() {
      if (typeof this.mutationCodes !== 'undefined' && this.mutationCodes !== null) {
        return Object.keys(this.mutationCodes).length > 0;
      }
      return false;
    },
    // TODO: make more robust solution for this workaround
    mutationCodeOptions() {
      if (this.hasMutationCodes) {
        return Object.keys(this.mutationCodes).map((key) => ({
          label: this.mutationCodes[key],
          value: key,
        }));
      }
      return [];
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
